import { useEffect, useRef, useState } from "react";

import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";


import {
  ANSWERSTATUSENUM,
  baseServiceUrl,
  proctoringGapInMinute,
  ServerStatus,
  SubmissionStatusEnum,
  urls,
} from "../../environment";
import toast from "react-hot-toast";
import "./OnlineExam.css";
import {
  base64toBlob,
  convertToISOFormat,
  encryptWithFixedKey,
  formatDateTime,
  isCameraAvailable,
} from "../../utils";

import OnlineExamView from "./OnlineExamView";
import { ServerCog } from "lucide-react";
import useExamStores from "../../stores/useExamStores";
import useUserStore from "../../stores/useUserStores";
import useExamServices from "../../context/useExamServices";
import FullscreenWarningModal from "../../components/FullScreenWarningModal";

const OnlineExam = () => {
  console.log("hit 32 >>>>>>>>>>>>>> ");

  const navigate = useNavigate();
  const mountRef = useRef<any>(null);
  const fullscreenCheckRef = useRef<NodeJS.Timeout | null>(null);
  const countdownTimerRef = useRef<NodeJS.Timeout | null>(null);

  const {
    userdetail,
    setLoading,
    loading,
    token,
    fullscreenmode,
    exam,
    setExamStarted,
    examStarted,
    isVisible,
    setStartExamMessage,
    startExamMessage,
    examQuestionDetails,
    setExamQuestionDetails,
    setCloseMyExam,
    closeMyExam,
    setSubmissionStateType,
    resumeDuration,
    setResumeDuration,
    examResultDetails,
    showWarningModalForFulScreen,
    setShowFullScreenCountDown,
    setShowWarningModalForFullscreen,
    fullscreenCountDown,
    setFullScreenMode,
  } = useUserStore();
  const location = useLocation();
  const examContext = useExamStores();
  const examService = useExamServices();
  const videoRef = useRef<any>(null);
  const currentTimeRef = useRef<any>(null);
  const resumeTimeRef = useRef<any>(null);
  const TimeMountRef = useRef<boolean>(false);
  const resumeTimeMountRef = useRef<boolean>(false);
  const getOutRef = useRef<any>(null);
  const timesUpRef = useRef<any>(null);
  const photoTimers = useRef<any[]>([]);
  const intervalTimer = useRef<any>(null);
  const clearUpperMessageRef = useRef<any>(null);
  const [timeLeft, setTimeLeft] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  const [secondsAnimated, setSecondsAnimated] = useState(false);

  const [webCamResponse, setWebCamResponse] = useState<any>(null);
  const [mobileControllerOpened, setMobileControllerOpened] =
    useState<boolean>(false);
  const [reviewCaseActivated, setReviewCaseActivated] =
    useState<boolean>(false);
  const [questionSavedMessage, setQuestionSavedMessage] = useState<string>("");
  const [questionErrorMessage, setQuestionErrorMessage] = useState<string>("");

  const [questionSet, setQuestionset] = useState<any[]>([]);
  const [questionSaveAlert, setQuestionSaveAlert] = useState<number>(-3);
  const [isReviewCase, setIsReviewCase] = useState<number>(-1);
  const questionSubmitMessageRef = useRef<any>(null);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [reviewedIndex, setReviewedIndex] = useState<number>(0);
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [reviewwdArray, setReviewedArray] = useState<Array<number>>([]);
  const [isResumeCase, setIsResumeCase] = useState<boolean>(false);
  const [warningModalOpen, setWarningModalOpen] = useState<boolean>(false);
  const [showWarningModal, setShowWarningModal] = useState<boolean>(false);
  const [isTimeOver, setIsTimeOver] = useState<boolean>(false);
  const [Answers, setAnswer] = useState<{
    ans_id: any;
    section: any;
  }>({ ans_id: -1, section: "" });
  const endTime = exam ? new Date(exam.exam_end_time).getTime() : 0;

  const errornotify = (msg: any) => toast.error(msg);

  const clearresponse = () => {
    setAnswer((prev) => ({ ...prev, ans_id: null }));
  };

  const captureAndSend = () => {
    if (!videoRef.current) return;
    const imageSrc = videoRef?.current?.getScreenshot();
    const imageBlob = base64toBlob(imageSrc);

    examService?.proctorSendImage({
      payload: {
        image: imageBlob,
        exam_id: exam.id,
        user_id: userdetail.id,
      },
      successCallback: (data) => {
        if (data) setWebCamResponse(data);
      },
    });
  };

  const stopAllTimers = () => {
    photoTimers.current.forEach(clearTimeout);
    clearInterval(intervalTimer.current);
  };

  const schedulePhotos = () => {
    // Clear any previous timers
    photoTimers.current.forEach(clearTimeout);
    photoTimers.current = [];

    // Generate 3 unique random seconds (0-59)
    const randomTimes = Array.from({ length: proctoringGapInMinute }, () =>
      Math.floor(Math.random() * 60)
    ).sort((a, b) => a - b);

    randomTimes.forEach((sec) => {
      const timerId = setTimeout(() => {
        captureAndSend();
      }, sec * 1000); // convert to ms
      photoTimers.current.push(timerId);
    });
  };
  const startMinuteLoop = () => {
    schedulePhotos(); // Initial call
    intervalTimer.current = setInterval(() => {
      schedulePhotos();
    }, 60000); // Every 60 seconds
  };

  const nextQuestion = async ({
    init = 0,
    exam_session_id,
    question_id = null,
    ans_id = null,
    session_key = null,
    section = null,
    isFinal = false,
    status = ANSWERSTATUSENUM.SKIP,
    finalCallback,
    timesUpCallback,
    noNext,
    skip_next,
  }: {
    noNext?: boolean;
    skip_next?: boolean;
    init: number;
    exam_session_id: any;
    question_id?: any;
    ans_id?: any;
    session_key?: any;
    section?: any;
    timesUpCallback?: any;
    finalCallback?: any;
    isFinal?: boolean;
    status: any;
  }) => {
    try {
      if (loading) return;
      setLoading(true);

      let rawPayload = {
        exam_session_id: exam_session_id,
        question_id: question_id,
        ans_id: ans_id,
        status,
        session_key,
      };

      const payload = encryptWithFixedKey(rawPayload);

      const response = await axios.post(
        baseServiceUrl + urls.nextQuestionUrl,
        payload,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      if (isFinal) finalCallback?.();
      if (timesUpCallback) timesUpCallback?.();
      if (
        examQuestionDetails &&
        Array.isArray(examQuestionDetails.questions) &&
        examQuestionDetails.questions.length > 0 &&
        examQuestionDetails.questions.length > currentIndex
      ) {
        const tempDetails = JSON.parse(JSON.stringify(examQuestionDetails));
        tempDetails.questions[currentIndex]["ans_id"] = ans_id;
        tempDetails.questions[currentIndex]["status"] =
          status === ANSWERSTATUSENUM.SKIP
            ? ANSWERSTATUSENUM.SKIP
            : status === ANSWERSTATUSENUM.REVIEW
            ? ANSWERSTATUSENUM.REVIEW
            : ans_id !== null && !!ans_id
            ? ANSWERSTATUSENUM.ATTEMPT
            : ANSWERSTATUSENUM.SKIP;
        if (
          tempDetails &&
          Array.isArray(tempDetails.questions) &&
          tempDetails.questions.length > 0 &&
          tempDetails.questions.length > currentIndex + 1
        ) {
          if (!noNext) {
            const newAnswerObject = {
              ans_id: tempDetails.questions[currentIndex + 1]?.ans_id
                ? tempDetails.questions[currentIndex + 1]?.ans_id
                : null,
              section: tempDetails.questions[currentIndex + 1]?.section,
            };
            setAnswer(newAnswerObject);
          }
        } else if (
          tempDetails &&
          Array.isArray(tempDetails.questions) &&
          tempDetails.questions.length > 0 &&
          tempDetails.questions.length - 1 === currentIndex
        ) {
          // setAnswer(newAnswerObject);
        }
        setExamQuestionDetails(tempDetails);
        if (isReviewCase > 0 && reviewwdArray.includes(currentIndex)) {
          findNextPrevFromReview({ next: true, prev: false });
        } else {
          if (
            currentIndex + 1 < examQuestionDetails.questions.length &&
            skip_next
          ) {
            setCurrentIndex(currentIndex + 1);
          }
          if (
            currentIndex + 1 < examQuestionDetails.questions.length &&
            !noNext
          ) {
            setCurrentIndex(currentIndex + 1);
          }
        }
      }

      setQuestionSavedMessage(
        response?.data?.message ?? "Answer Saved Successfully"
      );
    } catch (err: any) {
      setQuestionErrorMessage(
        err?.response?.data?.message || "Error encounter. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const setanswer = ({
    finalCallback,
    isFinal = false,
    timesUpCallback,
    status,
    skip_next,
  }: {
    finalCallback?: any;
    timesUpCallback?: any;
    isFinal?: boolean;
    status?: ANSWERSTATUSENUM;
    skip_next?: boolean;
  }) => {
    nextQuestion({
      skip_next: skip_next,
      noNext: !!status,
      init: 0,
      exam_session_id: examQuestionDetails
        ? examQuestionDetails?.session_id
        : undefined,
      question_id: examQuestionDetails?.questions[currentIndex].question_id,
      ans_id: status === ANSWERSTATUSENUM.SKIP ? null : Answers.ans_id,
      status: status
        ? status
        : isFinal
        ? !Answers.ans_id
          ? ANSWERSTATUSENUM.SKIP
          : examQuestionDetails?.questions[currentIndex]?.status
        : Answers.ans_id
        ? ANSWERSTATUSENUM.ATTEMPT
        : ANSWERSTATUSENUM.SKIP,
      // session_key: currentDisplay?.nex_ques?.session_key,
      finalCallback,
      isFinal,
      timesUpCallback,
    });
  };

  const markforreview = () => {
    nextQuestion({
      init: 0,
      exam_session_id: examQuestionDetails
        ? examQuestionDetails?.session_id
        : null,
      question_id: examQuestionDetails?.questions[currentIndex].question_id,
      // session_key: currentDisplay?.nex_ques?.session_key,
      ans_id: Answers.ans_id,
      status: ANSWERSTATUSENUM.REVIEW,
    });
  };

  // *************************
  const findNextPrevFromReview = ({
    prev = false,
    next = false,
  }: {
    prev: boolean;
    next: boolean;
  }) => {
    if (
      reviewwdArray.length &&
      prev &&
      reviewedIndex > 0 &&
      examQuestionDetails
    ) {
      setCurrentIndex(reviewwdArray[reviewedIndex - 1]);
      setReviewedIndex((prev) => prev - 1);
      setAnswer({
        ans_id: examQuestionDetails.questions[reviewwdArray[reviewedIndex - 1]]
          ?.ans_id
          ? examQuestionDetails.questions[reviewwdArray[reviewedIndex - 1]]
              ?.ans_id
          : null,
        section:
          examQuestionDetails.questions[reviewwdArray[reviewedIndex - 1]]
            ?.section,
      });
    } else if (reviewwdArray.length && next && examQuestionDetails) {
      if (reviewedIndex < reviewwdArray.length - 1) {
        setCurrentIndex(reviewwdArray[reviewedIndex + 1]);
        setReviewedIndex((prev) => prev + 1);

        setAnswer({
          ans_id: examQuestionDetails.questions[
            reviewwdArray[reviewedIndex + 1]
          ]?.ans_id
            ? examQuestionDetails.questions[reviewwdArray[reviewedIndex + 1]]
                ?.ans_id
            : null,
          section:
            examQuestionDetails.questions[reviewwdArray[reviewedIndex + 1]]
              ?.section,
        });
      } else {
        setCurrentIndex(reviewwdArray[reviewwdArray.length - 1]);
        setReviewedIndex(reviewwdArray.length - 1);

        setAnswer({
          ans_id: examQuestionDetails.questions[
            reviewwdArray[reviewwdArray.length - 1]
          ]?.ans_id
            ? examQuestionDetails.questions[
                reviewwdArray[reviewwdArray.length - 1]
              ]?.ans_id
            : null,
          section:
            examQuestionDetails.questions[
              reviewwdArray[reviewwdArray.length - 1]
            ]?.section,
        });
      }
    } else {
      if (examQuestionDetails) {
        setCurrentIndex(
          examQuestionDetails?.questions?.length - 1 > 0
            ? examQuestionDetails.questions.length - 1
            : 0
        );

        setAnswer({
          ans_id: examQuestionDetails?.questions[
            examQuestionDetails.questions.length - 1 > 0
              ? examQuestionDetails.questions.length - 1
              : 0
          ]?.ans_id
            ? examQuestionDetails.questions[
                examQuestionDetails.questions.length - 1 > 0
                  ? examQuestionDetails.questions.length - 1
                  : 0
              ]?.ans_id
            : null,
          section:
            examQuestionDetails?.questions[
              examQuestionDetails.questions.length - 1 > 0
                ? examQuestionDetails.questions.length - 1
                : 0
            ]?.section,
        });
      }
    }
  };
  const prevques = () => {
    if (currentIndex > 0) {
      if (
        examQuestionDetails &&
        Array.isArray(examQuestionDetails.questions) &&
        examQuestionDetails.questions.length > 0
      ) {
        if (examQuestionDetails.questions.length > currentIndex - 1) {
          if (isReviewCase > 0 && reviewwdArray.includes(currentIndex)) {
            findNextPrevFromReview({ next: false, prev: true });
          } else {
            setAnswer({
              ans_id: examQuestionDetails.questions[currentIndex - 1]?.ans_id
                ? examQuestionDetails.questions[currentIndex - 1]?.ans_id
                : null,
              section: examQuestionDetails.questions[currentIndex - 1]?.section,
            });
            setCurrentIndex((prev) => prev - 1);
          }
        }
      }
    }
  };

  const sendFinalResponse = async () => {
    EndExam();
  };
  const EndExam = async (successCallback?: () => void) => {
    // setLoading(false);
    //
    try {
      if (loading) return;
      setLoading(true);
      let rawPayload = {
        exam_session_id: examQuestionDetails
          ? examQuestionDetails?.session_id
          : null,
      };

      const payload = encryptWithFixedKey(rawPayload);
      const response = await axios.post(
        baseServiceUrl + urls.EndExamUrl,
        payload,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      if (response.data) {
        setExamStarted(false);
        setIsReviewCase(-1);
        navigate("/test/finalresult", { replace: true });
        successCallback?.();
      }
      setLoading(false);
      setCloseMyExam(false);
    } catch (err: any) {
      setLoading(false);
      errornotify(
        err?.response?.data?.message || "Error encounter. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const findOutReviewedItemAndIndex = () => {
    const matchesArray: Array<number> = [];
    setShowWarningModal(false);
    if (
      examQuestionDetails?.questions &&
      Array.isArray(examQuestionDetails.questions)
    ) {
      examQuestionDetails.questions.forEach((self: any, index: number) => {
        if (
          self?.status === ANSWERSTATUSENUM.REVIEW ||
          self?.status === ANSWERSTATUSENUM.SKIP
        ) {
          matchesArray.push(index);
        }
      });
      setReviewedArray(matchesArray);
      setReviewCaseActivated(true);
      setCurrentIndex(matchesArray[0]);

      setAnswer({
        ans_id: examQuestionDetails.questions[matchesArray[0]].ans_id,
        section: examQuestionDetails.questions[matchesArray[0]].section,
      });
      setReviewedIndex(0);
    }
  };

  const ignoreQuestionSaveAction = () => {
    if (questionSaveAlert < -1) return;
    if (questionSaveAlert === -1) {
      prevques();
      setQuestionSaveAlert(-3);
    } else if (questionSaveAlert >= 0) {
      const tempQuestionSaveAlert = questionSaveAlert;
      changeDisplay(tempQuestionSaveAlert);
      setQuestionSaveAlert(-3);
    }
  };

  const handlePrevious = () => {
    if (
      examQuestionDetails &&
      examQuestionDetails.questions &&
      Array.isArray(examQuestionDetails.questions) &&
      examQuestionDetails.questions.length > currentIndex &&
      examQuestionDetails.questions[currentIndex].ans_id != Answers.ans_id
    ) {
      setQuestionSaveAlert(-1);
    } else {
      prevques();
    }
  };

  const handleChangeDisplay = (questionIndex?: number) => {
    // if (
    //   examQuestionDetails &&
    //   examQuestionDetails.questions &&
    //   Array.isArray(examQuestionDetails.questions) &&
    //   examQuestionDetails.questions.length > currentIndex &&
    //   examQuestionDetails.questions[currentIndex].ans_id != Answers.ans_id
    // ) {
    //   setQuestionSaveAlert(Number(questionIndex));
    // } else {
    //   changeDisplay(Number(questionIndex));
    // }
    changeDisplay(Number(questionIndex));
  };

  const calculateTimeLeft = () => {
    if (!currentTimeRef.current) return;

    const now = currentTimeRef.current;
    const distance = endTime - now;
    // const distance =
    //   isResumeCase && resumeDuration
    //     ? resumeTimeRef.current * 1000
    //     : endTime - now;

    if (exam?.resume_exam && resumeDuration && resumeTimeRef.current > 0) {
      const hours = Math.floor((resumeTimeRef.current / (60 * 60)) % 24);
      const minutes = Math.floor((resumeTimeRef.current / 60) % 60);
      const seconds = Math.floor(resumeTimeRef.current % 60);

      setTimeLeft((prev) => {
        if (prev.seconds !== String(seconds).padStart(2, "0")) {
          setSecondsAnimated(true);
        }
        return {
          hours: String(hours).padStart(2, "0"),
          minutes: String(minutes).padStart(2, "0"),
          seconds: String(seconds).padStart(2, "0"),
        };
      });
    } else if (distance > 0) {
      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      setTimeLeft((prev) => {
        if (prev.seconds !== String(seconds).padStart(2, "0")) {
          setSecondsAnimated(true);
        }
        return {
          hours: String(hours).padStart(2, "0"),
          minutes: String(minutes).padStart(2, "0"),
          seconds: String(seconds).padStart(2, "0"),
        };
      });

      // Also update currentTime state if needed elsewhere
    } else {
      setTimeLeft({ hours: "00", minutes: "00", seconds: "00" });

      setIsTimeOver(true);
      setShowWarningModal(true);
    }
    if (isResumeCase && resumeDuration && resumeTimeRef.current)
      resumeTimeRef.current -= 1;

    // ⏱ Increment ref by 1 second for next tick

    currentTimeRef.current += 1000;
  };

  const getStattusCount = (type: ANSWERSTATUSENUM) => {
    if (
      examQuestionDetails &&
      !!examQuestionDetails.questions &&
      examQuestionDetails?.sections &&
      !!examQuestionDetails?.sections &&
      Array.isArray(examQuestionDetails.questions)
    ) {
      if (
        examQuestionDetails?.sections.length === 0 ||
        examQuestionDetails?.sections.length === 1
      ) {
        return examQuestionDetails.questions.filter(
          (self: any) => self.status === type
        ).length;
      }
      return Object.entries(
        examQuestionDetails.questions.customGroupBy((self: any) => self.section)
      )
        .map(([sectionKey, value]: any, pindex: number, parray) => value)
        .flat(2)
        .filter((item: any) => item.status === type).length;
    } else {
      return 0;
    }
  };
  const getNotVisitCount = () => {
    if (
      examQuestionDetails &&
      !!examQuestionDetails.questions &&
      examQuestionDetails?.sections &&
      !!examQuestionDetails?.sections &&
      Array.isArray(examQuestionDetails.questions)
    ) {
      if (
        examQuestionDetails?.sections.length === 0 ||
        examQuestionDetails?.sections.length === 1
      ) {
        return examQuestionDetails.questions.filter((self: any) => !self.status)
          .length;
      }
      return Object.entries(
        examQuestionDetails.questions.customGroupBy((self: any) => self.section)
      )
        .map(([sectionKey, value]: any, pindex: number, parray) => value)
        .flat(2)
        .filter((item: any) => !item.status).length;
    } else {
      return 0;
    }
  };

  const cancelSubmitAction = (isReviewd?: boolean) => {
    if (isReviewd) {
      setShowWarningModal(false);
      setReviewedArray([]);
      setReviewedIndex(0);
      // setIsReviewCase(-1);
    } else {
      setShowWarningModal(false);
    }
  };

  //  *************************  Navigate question from side panel ***************************************** //
  const changeDisplay = (questionIndex?: number) => {
    if (questionIndex === undefined || questionIndex < 0) return;
    if (
      (examQuestionDetails &&
        !examQuestionDetails.questions[questionIndex]?.status) ||
      (examQuestionDetails &&
        ![
          ANSWERSTATUSENUM.ATTEMPT,
          ANSWERSTATUSENUM.REVIEW,
          ANSWERSTATUSENUM.SKIP,
        ].includes(examQuestionDetails.questions[questionIndex]?.status as any))
    )
      return;
    if (
      examQuestionDetails &&
      examQuestionDetails?.questions &&
      Array.isArray(examQuestionDetails.questions) &&
      examQuestionDetails.questions.length > questionIndex &&
      questionIndex >= 0
    ) {
      setCurrentIndex(questionIndex);

      setAnswer({
        ans_id: examQuestionDetails.questions[questionIndex]?.ans_id,
        section: examQuestionDetails.questions[questionIndex]?.section ?? "",
      });
      if (isReviewCase > 0 && reviewwdArray.includes(questionIndex)) {
        setReviewedIndex(reviewwdArray.indexOf(questionIndex));
      }
    }
  };

  useEffect(() => {
    if (
      showWarningModal &&
      !!examQuestionDetails &&
      examQuestionDetails.questions.length > 0
    ) {
      const reviewedQuestions = examQuestionDetails.questions.filter(
        (self: any) =>
          self.status === ANSWERSTATUSENUM.REVIEW ||
          self.status === ANSWERSTATUSENUM.SKIP
      );
      setIsReviewCase(reviewedQuestions.length);
    }
  }, [showWarningModal]);

  // ******************   WHEN EXAM TIMES UP   FROM EXAM PAGE ********************************* //

  useEffect(() => {
    if (isTimeOver) {
      // setanswer({});
      timesUpRef.current = setTimeout(() => {
        sendFinalResponse();
        setSubmissionStateType(SubmissionStatusEnum.TIME_OUT);

        setShowWarningModal(false);
      }, 5000);
    } else {
      if (timesUpRef.current) {
        clearTimeout(timesUpRef.current);
      }
    }
    return () => {
      if (timesUpRef.current) {
        clearTimeout(timesUpRef.current);
      }
    };
  }, [isTimeOver]);

  const startCountdown = () => {
    if (countdownTimerRef.current) return;

    let timeLeft = 5;
    setShowFullScreenCountDown(timeLeft);

    countdownTimerRef.current = setInterval(() => {
      timeLeft -= 1;
      setShowFullScreenCountDown(timeLeft);

      if (timeLeft <= 0) {
        setCloseMyExam(true);
        sendFinalResponse();
        setSubmissionStateType(SubmissionStatusEnum.ILLEGAL);
        if (fullscreenCheckRef.current) {
          clearInterval(fullscreenCheckRef.current);
        }
        setShowWarningModal(false);
      }
    }, 1000);
  };

  const resetWarning = () => {
    setShowWarningModalForFullscreen(false);
    setShowFullScreenCountDown(5);
    if (countdownTimerRef.current) {
      clearInterval(countdownTimerRef.current);
      countdownTimerRef.current = null;
    }
  };

  useEffect(() => {
    return () => {
      resetWarning();
      if (fullscreenCheckRef.current) {
        clearInterval(fullscreenCheckRef.current);
      }
    };
  }, []);

  const checkFullscreenStatus = () => {
    const isFullscreen = !!(
      document.fullscreenElement ||
      (document as any).webkitFullscreenElement ||
      (document as any).mozFullScreenElement ||
      (document as any).msFullscreenElement ||
      (window.screen.availHeight || window.screen.height - 30) <=
        window.innerHeight
    );

    setFullScreenMode(isFullscreen);

    if (examStarted && !isFullscreen) {
      if (!showWarningModalForFulScreen) {
        setShowWarningModalForFullscreen(true);
        startCountdown();
      }
    } else if (isFullscreen) {
      resetWarning();
    }
  };

  const handleGoBackToTest = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if ((element as any).mozRequestFullScreen) {
      (element as any).mozRequestFullScreen();
    } else if ((element as any).webkitRequestFullscreen) {
      (element as any).webkitRequestFullscreen();
    } else if ((element as any).msRequestFullscreen) {
      (element as any).msRequestFullscreen();
    }
  };
  //******************   WHEN USER FORCEFULLY GET OUT FROM EXAM PAGE ********************************* //

  useEffect(() => {
    if (examStarted) {
      fullscreenCheckRef.current = setInterval(checkFullscreenStatus, 1000);

      const handleFullscreenChange = () => {
        checkFullscreenStatus();
      };

      document.addEventListener("fullscreenchange", handleFullscreenChange);
      document.addEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.addEventListener("mozfullscreenchange", handleFullscreenChange);
      document.addEventListener("MSFullscreenChange", handleFullscreenChange);

      return () => {
        if (fullscreenCheckRef.current) {
          clearInterval(fullscreenCheckRef.current);
        }
        document.removeEventListener(
          "fullscreenchange",
          handleFullscreenChange
        );
        document.removeEventListener(
          "webkitfullscreenchange",
          handleFullscreenChange
        );
        document.removeEventListener(
          "mozfullscreenchange",
          handleFullscreenChange
        );
        document.removeEventListener(
          "MSFullscreenChange",
          handleFullscreenChange
        );
      };
    }
  }, [examStarted, showWarningModal]);

  useEffect(() => {
    if (startExamMessage.length > 0) {
      clearUpperMessageRef.current = setTimeout(() => {
        setStartExamMessage("");
      }, 4000);
    }
    return () => {
      if (clearUpperMessageRef.current)
        clearTimeout(clearUpperMessageRef.current);
    };
  }, [exam]);

  useEffect(() => {
    let tempArray: any[] = [];

    let questionIndex = 0;
    if (
      examQuestionDetails &&
      examQuestionDetails?.questions &&
      Array.isArray(examQuestionDetails.questions) &&
      examQuestionDetails?.sections &&
      Array.isArray(examQuestionDetails.sections)
    ) {
      let tempVal = JSON.parse(JSON.stringify(examQuestionDetails));
      Object.entries(
        examQuestionDetails.questions.customGroupBy((self: any) => self.section)
      )
        .sort((a, b) => a[0].localeCompare(b[0]))
        .forEach(([key, value]: any) => {
          value.forEach((nestedItem: any, index: number) => {
            tempArray.push({
              ...nestedItem,
              questionIndex: questionIndex++,
            });
          });
        });

      tempVal["questions"] = JSON.parse(JSON.stringify(tempArray));
      if (tempArray.length)
        setExamQuestionDetails(JSON.parse(JSON.stringify(tempVal)));
    }
  }, [exam]);

  // Because of tab minimization my browser have close the exam

  useEffect(() => {
    if (examStarted && !!closeMyExam) {
      EndExam(() => setSubmissionStateType(SubmissionStatusEnum.ILLEGAL));
    }
  }, [examStarted, closeMyExam, isVisible]);

  useEffect(() => {
    if (examQuestionDetails && !TimeMountRef.current) {
      TimeMountRef.current = true;
      const result = formatDateTime(examQuestionDetails.current_datetime);
      currentTimeRef.current = new Date(
        convertToISOFormat(`${result.date} ${result.time}`)
      ).getTime();
    }
    if (resumeDuration && !resumeTimeMountRef.current) {
      resumeTimeMountRef.current = true;
      resumeTimeRef.current = resumeDuration;
    }
  }, [examQuestionDetails, resumeDuration]);
  useEffect(() => {
    if (exam) {
      setCurrentIndex(0);

      setAnswer({ ans_id: null, section: "" });
      setExamStarted(true);
      setQuestionset([]);

      if (exam?.resume_exam) setIsResumeCase(true);
      else setIsResumeCase(false);
    }
  }, [exam]);

  //  *************************************   ************************************************************* ///
  useEffect(() => {
    if (questionSavedMessage.trim().length) {
      questionSubmitMessageRef.current = setTimeout(() => {
        setQuestionSavedMessage("");
      }, 1000);
    }
    if (questionErrorMessage.trim().length) {
      questionSubmitMessageRef.current = setTimeout(() => {
        setQuestionErrorMessage("");
      }, 4000);
    }
    return () => {
      if (questionSubmitMessageRef.current)
        clearTimeout(questionSubmitMessageRef.current);
    };
  }, [currentIndex]);

  useEffect(() => {
    if (!userdetail) {
      navigate("/", { replace: true });
    }
  }, [userdetail]);

  //  ****************************   Proctoring functionality activate if exam is proctoring enabled  ***********************************//
  useEffect(() => {
    if (ServerStatus === "OFFLINE") return;
    (async () => {
      console.log("camera avilable >>> ");

      const isCameraAvilable = await isCameraAvailable();
      console.log("camera avilable   888>>> ", exam);
      if (exam?.is_proctor_enabled && isCameraAvilable) {
        startMinuteLoop();
      }
    })();

    return () => {
      stopAllTimers();
    };
  }, [exam, examContext.proctorAuthToken, ServerStatus]);

  useEffect(() => {
    const timer = setInterval(() => calculateTimeLeft(), 1000);
    return () => {
      if (location.pathname !== "/test/ongoing") {
        if (timer) clearInterval(timer);
      }
    };
  }, [exam.exam_end_time, isResumeCase]);

  //  *********************
  useEffect(() => {
    if (
      examQuestionDetails &&
      examQuestionDetails.questions[currentIndex]?.ans_id &&
      currentIndex === 0 &&
      mountRef.current === false
    ) {
      mountRef.current = true;

      setAnswer({
        ans_id: examQuestionDetails.questions[currentIndex]?.ans_id
          ? examQuestionDetails.questions[currentIndex]?.ans_id
          : null,
        section: examQuestionDetails.questions[currentIndex]?.section,
      });
    }
  }, [currentIndex, examQuestionDetails]);

  return (
    <>
      <FullscreenWarningModal
        show={showWarningModalForFulScreen}
        countdown={fullscreenCountDown}
        onGoBack={handleGoBackToTest}
      />
      <OnlineExamView
        exam={exam}
        isResumeCase={isResumeCase}
        handlePrevious={handlePrevious}
        videoRef={videoRef}
        setReviewCaseActivated={setReviewCaseActivated}
        reviewCaseActivated={reviewCaseActivated}
        isReviewCase={isReviewCase}
        setAnswer={setAnswer}
        setanswer={setanswer}
        setShowWarningModal={setShowWarningModal}
        warningModalOpen={warningModalOpen}
        setWarningModalOpen={setWarningModalOpen}
        showWarningModal={showWarningModal}
        cancelSubmitAction={cancelSubmitAction}
        sendFinalResponse={sendFinalResponse}
        findOutReviewedItemAndIndex={findOutReviewedItemAndIndex}
        isTimeOver={isTimeOver}
        setSubmissionStateType={setSubmissionStateType}
        questionSaveAlert={questionSaveAlert}
        setQuestionSaveAlert={setQuestionSaveAlert}
        ignoreQuestionSaveAction={ignoreQuestionSaveAction}
        selectedImage={selectedImage}
        examQuestionDetails={examQuestionDetails}
        setSelectedImage={setSelectedImage}
        setWebCamResponse={setWebCamResponse}
        questionSavedMessage={questionSavedMessage}
        webCamResponse={webCamResponse}
        markforreview={markforreview}
        currentIndex={currentIndex}
        Answers={Answers}
        questionErrorMessage={questionErrorMessage}
        timeLeft={timeLeft}
        secondsAnimated={secondsAnimated}
        loading={loading}
        clearresponse={clearresponse}
        reviewedIndex={reviewedIndex}
        reviewwdArray={reviewwdArray}
        mobileControllerOpened={mobileControllerOpened}
        setMobileControllerOpened={setMobileControllerOpened}
        getStattusCount={getStattusCount}
        getNotVisitCount={getNotVisitCount}
        handleChangeDisplay={handleChangeDisplay}
      />
    </>
  );
};

export default OnlineExam;
